import { render } from "./Login.vue?vue&type=template&id=66fa0b4d&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=66fa0b4d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-66fa0b4d"

export default script